import { router } from "..";
import { getFenceAlarm2 } from "../api/fencealarm2s_{imei}";
import { getPrices } from "../api/prices";
import { deviceCard, formatSubscriptionStatus } from "../device/device_card";
import { locale, relativeTimeString, t } from "../locale";
import { addNotificationListener } from "../mobile";
import { state } from "../state";
import { keyValueParagraph } from "../view/components";
import { Html } from "../view/html";
import { MaterialDesign } from "../view/material_design";
import { getFencealarm2Warnings } from "./fa2_warnings";

/**
 * @param {Fencealarm2} fa2
 */
async function fencealarm2Card(fa2) {
	addNotificationListener("fencealarm2", fa2.Imei, () => {
		getFenceAlarm2(fa2.Imei).then((fa2) => {
			state.fencealarm2s[fa2.Imei] = fa2;
			// refresh(fa2)
		});
	});

	return deviceCard({
		deviceName: fa2.Metadata.Name,
		deviceType: "fencealarm2",
		productName: "FenceAlarm2",
		warnings: getFencealarm2Warnings(fa2),
		lines: [
			keyValueParagraph(
				locale.string({
					enGB: "Device status",
					deDE: "Gerätestatus",
					frFR: "État de l'appareil",
					svSE: "Enhetsstatus",
				}),
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Voltage",
					deDE: "- Spannung",
					frFR: "- Tension",
					svSE: "- Spänning",
				}),
				`${fa2.Voltage} V`,
			),
			keyValueParagraph(
				locale.string({
					enGB: "- Alarm level",
					deDE: "- Alarmstufe",
					frFR: "- Niveau d'alarme",
					svSE: "- Larmnivå",
				}),
				`${fa2.PendingResponse_v0_3?.Config?.AlarmLevel && fa2.PendingResponse_v0_3.Config.AlarmLevel !== fa2.Config_v0_3.AlarmLevel ? "*" : ""} ${fa2.Config_v0_3.AlarmLevel} V`,
			),
			keyValueParagraph(
				t("deviceCard.lastActive")(),
				relativeTimeString(fa2.LastUplinkAt),
			),
			keyValueParagraph(locale.strings.subscription),
			keyValueParagraph(
				locale.string({
					enGB: "- Plan",
					deDE: "- Plan",
					frFR: "- Plan",
					svSE: "- Plan",
				}),
				await formatSubscriptionPlan(fa2),
			),
			keyValueParagraph(...formatSubscriptionStatus(fa2.Subscription)),
		],
		buttons: [
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "monitoring",
					onClick: () => router.jump(`/fencealarm2/${fa2.Imei}/logs`),
				}),
			),
			Html.anchor(
				{},
				MaterialDesign.icon({
					id: "settings",
					onClick: () => router.jump(`/fencealarm2/${fa2.Imei}`),
				}),
			),
		],
	});
}

/**
 * @param {Fencealarm2} fa2
 */
async function formatSubscriptionPlan(fa2) {
	if (fa2.Subscription.Trialing) return locale.strings.trial;

	const { Fencealarm2Month, Fencealarm2Year } = await getPrices();

	switch (fa2.Subscription.PriceIds.Current) {
		case Fencealarm2Month.Id:
			return locale.string({
				deDE: "Monatlich",
				enGB: "Monthly",
				frFR: "Mensuel",
				svSE: "Månadsvis",
			});
		case Fencealarm2Year.Id:
			return locale.string({
				deDE: "Jährlich",
				enGB: "Yearly",
				frFR: "Annuel",
				svSE: "Årsvis",
			});
	}

	const expiryTime = new Date(fa2.Subscription.ExpiresAt);
	if (Date.now() < expiryTime.getTime()) return "";

	return locale.strings.none;
}

export { fencealarm2Card };
